export default __webpack_public_path__ + "static/media/001.52a24e72.svg";